import { render, staticRenderFns } from "./FormComponents.vue?vue&type=template&id=50ccf66a&"
import script from "./FormComponents.vue?vue&type=script&lang=js&"
export * from "./FormComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports